/* eslint-disable */
import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import { TargetStepProps } from "../../target-configurator.types";
import SidebarStepFooter from "src/modules/striim-ai-sidebar/tools/tql-tools/source-configurator/sidebar-step-footer";
import TargetFormConfigAI from "../../target-form-config/target-form-config-ai";

const TargetFormConfigStep = ({ state, onChange, onNext, onCancel }: TargetStepProps) => {
    const formRef = useRef<any>(null);
    const [isFormValid, setIsFormValid] = useState(false);

    return (
        <Box sx={{ width: "100%" }}>
            <TargetFormConfigAI
                targetType={state.targetType}
                initialValues={state.formValues}
                formRef={formRef}
                onChange={values => onChange({ formValues: values })}
                setFormValid={setIsFormValid}
            />
            <SidebarStepFooter showBack={false} onCancel={onCancel} onNext={onNext} nextDisabled={!isFormValid} />
        </Box>
    );
};

export default TargetFormConfigStep;
